import React, { useEffect } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { BUTTONS, HEADINGS } from "@/utils/constants/appConstants/commonConstants";
import { fetchAllRoles } from "@/services/role.service";
import { CheckboxCard } from "@/components/cards/CheckboxCard";
import { ToggleListSkeleton } from "@/components/skeletons";
import { Button } from "@/components/ui/button";
import NoDataAvailable from "@/components/cards/NoDataAvailable";

interface AddRolesModalProps {
    show?: boolean;
    onHide?: () => void;
    userroles: any[];
    setUserRoles: (roles: any[]) => void;
}

const AddRolesModal = (props: AddRolesModalProps) => {
    const [allRoles, setAllRoles] = React.useState<any>([]);
    const [loading, setLoading] = React.useState(false);

    const getRolesListFromAPI = () => {
        setLoading(true);
        fetchAllRoles((response: any) => {
            setLoading(false);
            const new_roles_list = response?.data?.roles.map((role: { checked: boolean; name: any }) => {
                role.checked = props.userroles?.some((obj: { name: any }) => obj.name === role.name) ? true : false;
                return role;
            });
            setAllRoles(new_roles_list);
        }, (error: any) => { setLoading(false); console.log(error); });
    };

    useEffect(() => { getRolesListFromAPI(); }, []);

    useEffect(() => {
        if (props.userroles.length === 0) {
            setAllRoles(allRoles.map((role: any) => ({ ...role, checked: false })));
        }
    }, [props.userroles.length]);

    const onChangeRole = (e: { target: { name: any; checked: any } }) => {
        setAllRoles(allRoles.map((role: { name: any }) =>
            e.target.name === role.name ? { ...role, checked: e.target.checked } : role
        ));
    };

    const handleRoles = () => {
        props.setUserRoles(allRoles.filter((role: any) => role.checked));
        props.onHide?.();
    };

    return (
        <Dialog open={props.show} onOpenChange={(open) => { if (!open) props.onHide?.(); }}>
            <DialogContent className="gs-tag-dialog gs-tag-dialog--wide">
                <div className="gs-tag-dialog__header">
                    <h4 className="gs-tag-dialog__title" id="add-role-title">
                        {HEADINGS.ADD_ROLES}
                    </h4>
                </div>

                <div className="gs-tag-dialog__body gs-tag-dialog__body--list">
                    <ul className="gs-picker-dialog-list">
                        {loading ? (
                            <ToggleListSkeleton rowCount={5} labelWidth="10rem" />
                        ) : allRoles.length > 0 ? (
                            allRoles.map((role: any, key: number) =>
                                role.name !== "superadmin" && (
                                    <li key={role.id}>
                                        <CheckboxCard index={key} onChange={onChangeRole} name={role.name} id={role.id} checked={role.checked}>
                                            <span id={`role-name-${key}`}>{role.name}</span>
                                        </CheckboxCard>
                                    </li>
                                )
                            )
                        ) : (
                            <li className="gs-picker-dialog-empty">
                                <NoDataAvailable>
                                    <p id="no-role-msg">No Role Yet</p>
                                </NoDataAvailable>
                            </li>
                        )}
                    </ul>
                </div>

                <div className="gs-tag-dialog__footer">
                    <Button id="add-role-done-btn" className="gs-tag-dialog__submit" onClick={handleRoles}>
                        {BUTTONS.ADD}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default AddRolesModal;
